function isNumberInRange(range, num) {
  let [min, max] = range;
  if (min > max) [min, max] = [max, min]; // Swap if range is in reverse order

  return num >= min && num <= max;
}

export default isNumberInRange;
